import Skeleton from "@/common/components/Skeleton";

const EstablishmentChoiceListSkeleton = () => {
  return (
    <div className="flex flex-col gap-4 bg-white-100 p-4 rounded-md">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Skeleton className="rounded-full size-5" />

          <Skeleton className="h-5 w-32" />
        </div>

        <Skeleton className="size-5" />
      </div>

      <div className="flex flex-col gap-1">
        <Skeleton className="h-4 w-1/2" />

        <Skeleton className="h-4 w-1/3" />
      </div>

      <div className="flex gap-2">
        <div className="flex flex-col gap-1">
          <Skeleton className="h-3 w-20" />

          <Skeleton className="h-3 w-28" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-3 w-20" />

          <Skeleton className="h-3 w-28" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-3 w-20" />

          <Skeleton className="h-3 w-28" />
        </div>
      </div>
    </div>
  );
}

export default EstablishmentChoiceListSkeleton;
